import React from "react";

const history = [
  {
    header: "Amount withdrawn :",
    amount: "₹ 50,000",
    date: "27/04/2024",
    id: "#12345",
    status: (
      // <div className="w-full flex items-center justify-center">
      <button className="w-[99px] h-[33px] bg-[#FFF7CB] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
        In Process
      </button>
      // </div>
    ),
  },
  {
    header: "Amount withdrawn :",
    amount: "₹ 50,000",
    date: "27/04/2024",
    id: "#12345",
    status: (
      <button className="w-[103px] h-[33px] bg-[#C1FFA6] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
        Successful
      </button>
    ),
  },
  {
    header: "Amount withdrawn :",
    amount: "₹ 50,000",
    date: "27/04/2024",
    id: "#12345",
    status: (
      <button className="w-[103px] h-[33px] bg-[#C1FFA6] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
        Successful
      </button>
    ),
  },
  {
    header: "Amount withdrawn :",
    amount: "₹ 50,000",
    date: "27/04/2024",
    id: "#12345",
    status: (
      <button className="w-[103px] h-[33px] bg-[#C1FFA6] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
        Successful
      </button>
    ),
  },
  {
    header: "Amount withdrawn :",
    amount: "₹ 50,000",
    date: "27/04/2024",
    id: "#12345",
    status: (
      <button className="w-[103px] h-[33px] bg-[#C1FFA6] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
        Successful
      </button>
    ),
  },
  {
    header: "Amount withdrawn :",
    amount: "₹ 50,000",
    date: "27/04/2024",
    id: "#12345",
    status: (
      <button className="w-[103px] h-[33px] bg-[#C1FFA6] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
        Successful
      </button>
    ),
  },
  {
    header: "Amount withdrawn :",
    amount: "₹ 50,000",
    date: "27/04/2024",
    id: "#12345",
    status: (
      <button className="w-[99px] h-[33px] bg-[#FFF7CB] rounded-[5px] font-medium text-[12px] flex items-center justify-center text-black">
        In Process
      </button>
    ),
  },
];

const WithdrawalHistory = () => {
  return (
    <div className="w-full h-[620px] py-[3px] items-center mt-[18px] flex flex-col overflow-y-scroll gap-y-[15px]">
      {history.map((item) => (
        <div key={item}>
          <div className="w-[936px] h-[98px] bg-white rounded-[10px] py-[19px] px-[25px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <div className="flex flex-row justify-between">
              <div className="flex flex-col h-[51px] justify-between">
                <h4 className="w-[122px] h-[18px] text-black text-start font-medium text-[12px]">
                  {item.header}
                </h4>
                <p className="w-[70px] h-[24px] text-start text-black font-semibold text-[16px]">
                  {item.amount}
                </p>
              </div>

              <div className="flex flex-col text-end h-[55px] justify-between">
                <div className="w-full flex items-center justify-end">
                  {item.status}
                </div>
                <div className="flex flex-row gap-x-[17px] items-center">
                  <p className="w-[109px] h-[18px] text-[12px] text-black font-medium">
                    Date : {item.date}
                  </p>
                  <hr className="w-[0.5px] h-[15px] transform bg-black opacity-25 rounded-full" />
                  <p className="w-[141px] h-[18px] text-black font-medium text-[12px]">
                    Transaction ID : {item.id}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WithdrawalHistory;
